export default "__VITE_ASSET__CD_j3hjN__"